const toLocaleString = (value): string => {
  const options = {
    minimumFractionDigits: 0,
  };
  const LOCALE = 'ru';

  if (Number(value)) {
    return value.toLocaleString(LOCALE, options);
  }

  return value;
};

export default toLocaleString;
